<template>
  <div data-organization="true" />
</template>

<script>
import profileMixin from '~/mixins/profileMixin';

export default {
  name: 'Profile',
  mixins: [profileMixin],
  layout: 'profile',
};
</script>
